import React, { useEffect } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { CheckCircle as CompleteIcon } from '@mui/icons-material';
import { useTracking } from '../../../hooks/useTracking';
import RichTextContent from '../../common/RichTextContent';

interface InfoTextPlayerProps {
    lesson: any;
    courseId?: number;
    userId: number;
    userEmail: string;
    onComplete: () => void;
}

const InfoTextPlayer: React.FC<InfoTextPlayerProps> = ({
    lesson,
    courseId,
    userId,
    userEmail,
    onComplete
}) => {
    const content = lesson.content || {};

    // Initialize tracking
    const {
        startLesson,
        completeLesson,
        isLoading: trackingLoading,
        error: trackingError
    } = useTracking({
        lessonId: lesson.id,
        lessonTitle: lesson.title,
        courseId,
        userId,
        userEmail,
    });

    // Start lesson tracking on mount
    useEffect(() => {
        startLesson();
    }, [startLesson]);

    const { html = '' } = content;

    return (
        <Box>
            <Paper sx={{ p: 4, mb: 3 }}>
                {html && <RichTextContent html={html} />}

                {!html && (
                    <Typography color="text.secondary" sx={{ fontStyle: 'italic' }}>
                        Kein Inhalt verfügbar.
                    </Typography>
                )}
            </Paper>

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    variant="contained"
                    size="large"
                    startIcon={<CompleteIcon />}
                    onClick={async () => {
                        try {
                            await completeLesson({ success: true });
                            onComplete();
                        } catch (error) {
                            console.error('Error completing lesson:', error);
                            // Still call onComplete to allow navigation
                            onComplete();
                        }
                    }}
                >
                    Bestätigen
                </Button>
            </Box>
        </Box>
    );
};

export default InfoTextPlayer;
